import { API_URL, getApiUrl } from '@/utils/api';
import ApiBase from './ApiBase';

export default class NotebookService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.USER, '/notebookToPick');

  getUserNotebook(pickId: string) {
    return this.api.getJSON(`${NotebookService.baseUrl}/${pickId}`);
  }

  updateUserNotebook({ pickId, note }) {
    return this.api.postJSON(`${NotebookService.baseUrl}/${pickId}`, note);
  }
}
